export default __webpack_public_path__ + "static/media/transport-truck.a9d5780f.png";